module.exports = __webpack_public_path__ + "static/media/logo-alert-gasoil-2.dbf82eb0.svg";